import config from '@/config';
import { PLATFORMS, PRODUCTS } from '../constants/game';
import { GameInfo } from '@/api/aggregation/types';
import { APIServiceType } from '@/api/types';
import { isAndroidWrapper } from '../helpers/wrapperHelpers';
import { isMobile } from 'react-device-detect';

export const getProduct = () => process.env.PRODUCT;

export const getBrand = () => {
  return process.env.BRAND?.toLowerCase();
};
export const getDomain = () => config.domain;

export const getPlatform = ():
  | 'desktop'
  | 'xsell'
  | 'android'
  | 'mobile_web' => {
  if (process.env.PRODUCT === PRODUCTS.XSELL) {
    return PLATFORMS.XSELL;
  } else if (isAndroidWrapper()) {
    return PLATFORMS.Android;
  } else if (isMobile) {
    return PLATFORMS.MobileWeb;
  }

  return PLATFORMS.Desktop;
};

export const getProviderRef = (
  gameInfo: GameInfo & { platform: string; gameUid?: string },
) => {
  const providerRef =
    gameInfo.platform === 'desktop'
      ? gameInfo?.rgs_code_desktop
      : gameInfo?.rgs_code_mobile;

  return providerRef;
};

export const getBaseURL = () => {
  let fabricURL = config?.casinoWebUrl;
  const domain = config.domain;

  /**
   * Raw hostname: devstack-liviucojocaru-canada.gw.devstack.casino.qa.canada.fndl.dev/
   * Split over domain: devstack-liviucojocaru-canada.gw.devstack
   * Split over .gw: devstack-liviucojocaru-canada.devstack
   */

  const devstackName = window.location.hostname
    .split(`.${domain}`)[0]
    .split('.gw')
    .join('');
  const env = config.env;

  fabricURL =
    process.env.NODE_CONFIG_ENV === 'local-development'
      ? `${fabricURL}:4000`
      : fabricURL;

  if (env && /devstack/.test(env) && /{namespace}/.test(fabricURL)) {
    fabricURL = fabricURL?.replace(/{namespace}/g, devstackName);
  }

  return fabricURL;
};

export const getEndpoint = (service: APIServiceType) =>
  config?.fabric?.endpoints[service][service];
